<template>
  <form class="ui form">
    <div class="two fields">
      <div class="field">
        <label>{{ $t("name") }}</label>
        <input
          type="text"
          name="name"
          v-model="setup.name"
          :placeholder="$t('name')"
        />
      </div>
      <div class="field">
        <label>{{ $t("access route") }}</label>
        <input
          type="text"
          name="access_route"
          v-model="setup.access_route"
          :placeholder="$t('access route')"
        />
      </div>
    </div>
    <div class="field">
      <label>{{ $t("description") }}</label>
      <textarea
        name="description"
        v-model="setup.description"
        rows="2"
      ></textarea>
    </div>
  </form>
</template>

<script>
import filters from "@/filters";

export default {
  name: "PrototypeComposerGeneral",
  components: {},
  filters: filters,
  props: {
    setup: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>
